import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useBranding } from '../context/BrandingContext';
import './BottomNav.css';

function BottomNav({ activeTab, onTabChange, onOrdersClick, onAccountClick }) {
  const { t } = useTranslation();
  const { isDark, toggleTheme } = useTheme();
  const { darkModeEnabled } = useBranding();

  const tabs = [
    {
      id: 'menu',
      icon: 'restaurant_menu',
      label: t('nav.menu'),
    },
    {
      id: 'orders',
      icon: 'receipt_long',
      label: t('nav.orders'),
      onClick: onOrdersClick,
    },
    {
      id: 'account',
      icon: 'person',
      label: t('nav.account'),
      onClick: onAccountClick,
    },
  ];

  const handleTabClick = (tab) => {
    if (tab.onClick) {
      tab.onClick();
    } else {
      onTabChange(tab.id);
    }
  };

  return (
    <nav className="bottom-nav" aria-label={t('nav.mainNavigation')}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`bottom-nav-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => handleTabClick(tab)}
          aria-label={tab.label}
        >
          <div className="nav-icon-wrapper">
            <span className="material-icons" aria-hidden="true">{tab.icon}</span>
          </div>
          <span className="nav-label">{tab.label}</span>
        </button>
      ))}
      {darkModeEnabled !== false && (
        <button
          className="bottom-nav-item bottom-nav-theme"
          onClick={toggleTheme}
          aria-label={isDark ? t('theme.light') : t('theme.dark')}
        >
          <div className="nav-icon-wrapper">
            <span className="material-icons" aria-hidden="true">
              {isDark ? 'light_mode' : 'dark_mode'}
            </span>
          </div>
          <span className="nav-label">
            {isDark ? t('theme.light') : t('theme.dark')}
          </span>
        </button>
      )}
    </nav>
  );
}

export default BottomNav;
